import React from "react";
import { makeStyles } from "@material-ui/core";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: 0,
  },
}));

const IapSelectHelpText = () => {
  const classes = useStyles();
  return (
    <div>
        <Typography className={classes.header} variant="body2">
            <strong>Filtering Options:</strong>
        </Typography>

        <Typography className={classes.header} variant="body2">
            <strong>IAP Select Titles:</strong>
        </Typography>
          <ul>
            <li>
              If you'd like IAP Select books across all libraries, pick{" "}
              <strong>ALL</strong>.
            </li>
            <li>
              If you'd like a report of IAP Select books for a specific library,
              pick the organization from the drop-down list.
            </li>
          </ul>

        <Typography className={classes.header} variant="body2">
            <strong>IAP Submission Report:</strong>
        </Typography>
        <ul>
            <li>To get started select a date range not exceeding 6 months</li>
            <li>
                If you'd like a report of IAP submissions across all libraries, pick{" "}
                <strong>ALL</strong>.
            </li>
            <li>
                If you'd like a report of IAP submissions for a specific area, pick the
                country and the region from the drop-down list.
            </li>
        </ul>

        <Typography className={classes.header} variant="body2">
            <strong>IAP Contest Submissions:</strong>
        </Typography>
        <ul>
            <li>To get started select a date range not exceeding 6 months</li>
            <li>
                If you'd like a report of contest submissions across all libraries, pick{" "}
                <strong>ALL</strong>.
            </li>
            <li>
                If you'd like a report of the contest submissions for a specific area, pick the country
                and the region from the drop-down list.
            </li>
        </ul>


        <Typography className={classes.header} variant="body2">
            <strong>Data Fields:</strong>
        </Typography>
          <ul>
            <li>Each inventory item could include the following fields:</li>
            <ul>
              <li>MediaId</li>
              <li>Title</li>
              <li>Subtitle</li>
              <li>ISBN</li>
              <li>Region</li>
              <li>Local Library</li>
              <li>Full Name</li>
              <li>Contributor Role</li>
            </ul>
          </ul>
    </div>
  );
};

export default IapSelectHelpText;
